import { useTakeoverExperimentContext } from 'modules/experiments/contexts';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { WinningCriteriaSettings } from './WinningCriteriaSettings';
import { StyledWinningCriteriaSectionHeader } from '../styled';
import {
  ReadOnlySettingsWrapper,
  StyledSettingsFieldValue,
  StyledSettingsFormField,
} from './Styled';

export const SendTimeSettings = () => {
  const { t } = useExperimentsTranslations();
  const {
    sendTimeMetaInfo: { sendTimeStartTimeZone, sendTimeUseRecipientTimeZones },
  } = useTakeoverExperimentContext();

  return (
    <>
      <WinningCriteriaSettings />
      <StyledWinningCriteriaSectionHeader>
        {t('settings.sendTime.header')}
      </StyledWinningCriteriaSectionHeader>
      <ReadOnlySettingsWrapper>
        <StyledSettingsFormField
          labelText={t('settings.sendTime.startTimezone')}
          isHorizontalLayout
        >
          <StyledSettingsFieldValue>{sendTimeStartTimeZone}</StyledSettingsFieldValue>
        </StyledSettingsFormField>
        <StyledSettingsFormField
          labelText={t('settings.sendTime.sendInRecepientsTimezone')}
          isHorizontalLayout
        >
          <StyledSettingsFieldValue>
            {sendTimeUseRecipientTimeZones ? t('bool.yes') : t('bool.no')}
          </StyledSettingsFieldValue>
        </StyledSettingsFormField>
      </ReadOnlySettingsWrapper>
    </>
  );
};
